export default __webpack_public_path__ + "static/media/015_photo.6b4724fc.jpg";